/* Santas Vault order-by countdown. ONE table of dates for the whole site.

   22 Sep 2026 audit. What this replaced: a single POST_CUTOFF of 2026-12-19,
   which is a SATURDAY, with each element working back a number of business
   days from it. Stocked items got three different dates for the same product
   (product page 16 Dec on the default 3 days, cart 18 Dec on 1 day, delivery
   page 19 Dec), and nothing allowed for the stocked dispatch time the site
   itself publishes ("usually one to two business days").

   These dates are the same table as /pages/christmas-delivery-dates. They are
   worked back from Thursday 24 December using the slow end of the published
   transit times (metro 4, Perth/Hobart 6, regional 8, remote 12 business days),
   7 business days to make a personalised item (Tony, 22 Sep 2026: "we make in
   3-7 business days seasonally driven", and December is the busy end; it was
   3), 2 for a stocked item to leave the warehouse, and
   5 to 8 business days for bulky cartons. Australia Post had not published its
   2026 dates on 22 Sep 2026: when it does, check this table AND that page.

   Elements: <div data-sv-cutoff data-sv-kind="personalised|blanket|stocked|bulky|overseas">.
   Old markup with only data-production-days is read as personalised when the
   number is 3 or more, stocked otherwise. */
(function(){
  var CUT = {
    personalised: { metro:'2026-12-09', perth:'2026-12-07', regional:'2026-12-03', remote:'2026-11-27' },
    stocked:      { metro:'2026-12-16', perth:'2026-12-14', regional:'2026-12-10', remote:'2026-12-04',
                    express_metro:'2026-12-18', express_perth:'2026-12-17' },
    bulky:        { metro:'2026-12-10', perth:'2026-12-10', regional:'2026-12-07', remote:'2026-12-04' },
    // Photo blankets: 10 business days on the press (vault.production_days), three more than
    // the 7 the personalised row allows, so every date is three business days earlier. 23 Sep 2026.
    blanket:      { metro:'2026-12-04', perth:'2026-12-02', regional:'2026-11-30', remote:'2026-11-24' },
    // 0.43.0: the Your Design or Ours pieces our print partners make in 5 to 9 business days (store
    // 0.37.0 states that range on each listing). Two business days more making than the personalised
    // row, so every date is two business days earlier: 9 + 4 metro, 9 + 6, 9 + 8, 9 + 12 back from 24 Dec.
    partner:      { metro:'2026-12-07', perth:'2026-12-03', regional:'2026-12-01', remote:'2026-11-25' },
    // Pet bandanas are printed to order in the USA (Printed Mint, via Printify)
    // and posted to Australia. Printify's own promise for that route is 10 to 30
    // business days in the post, after about 3 business days to print, so the
    // date is 33 business days back from Christmas Eve. It was 12 Nov, worked
    // from "up to five weeks"; the supplier's upper bound is six. 22 Sep 2026.
    // Santa sacks joined this row on 23 Sep 2026: printed to order by Print Clever in Swindon,
    // UK, through Printify (blueprint 823), about 2 business days to print, the same 10 to 30
    // business days in the post, so the same date.
    overseas:     { metro:'2026-11-05', perth:'2026-11-05', regional:'2026-11-05', remote:'2026-11-05' }
  };
  window.SV_CUTOFF = CUT;

  // 0.43.0, 24 Sep 2026 (delivery audit). How long each route takes from order to door for a
  // metro address, in business days: [fastest, slowest]. Same figures as the shipping policy and
  // the delivery dates page: dispatch 1 to 2 (stocked), making 3 to 7 (personalised) or 10
  // (blankets), then metro transit 2 to 4, or 5 to 8 for bulky cartons; overseas prints about
  // 3 days then 10 to 30 in the post.
  var ROUTE = { stocked:[3,6], bulky:[6,10], personalised:[5,11], partner:[7,13], blanket:[12,14], overseas:[13,33] };
  window.SV_ROUTE = ROUTE;
  var SHOW_DAYS = 21;   // no countdown further out than this: a far date says "no rush"
  var SHOW_CLOCK = 72;  // hours and minutes only in the final 72 hours

  function end(iso){ return new Date(iso + 'T23:59:59+10:00'); }
  function kindOf(el){
    var k = el.getAttribute('data-sv-kind');
    if (k && CUT[k]) return k;
    var d = parseInt(el.getAttribute('data-production-days'), 10);
    return (!isNaN(d) && d < 3) ? 'stocked' : 'personalised';
  }
  var TZ = { timeZone:'Australia/Brisbane' };
  function fmt(d){ return d.toLocaleDateString('en-AU', Object.assign({ weekday:'long', day:'numeric', month:'long' }, TZ)); }
  var WD = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'], MO = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function fmtShort(d){
    var p = d.toLocaleDateString('en-CA', TZ).split('-');   // Brisbane calendar date
    var x = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2]));
    return WD[x.getUTCDay()] + ' ' + x.getUTCDate() + ' ' + MO[x.getUTCMonth()];
  }
  function bneToday(){
    var p = new Date().toLocaleDateString('en-CA', TZ);   // YYYY-MM-DD in Brisbane
    return new Date(p + 'T12:00:00+10:00');
  }
  function addBiz(d, n){
    var x = new Date(d.getTime()), wd;
    while (n > 0){
      x = new Date(x.getTime() + 86400000);
      wd = new Date(x.toLocaleDateString('en-CA', TZ) + 'T12:00:00+10:00').getUTCDay();
      if (wd !== 0 && wd !== 6) n--;
    }
    return x;
  }
  function note(el, text){
    var n = el.querySelector('.sv-cutoff__note');
    if (!n){
      n = document.createElement('p');
      n.className = 'sv-cutoff__note';
      n.style.cssText = 'margin:.5rem 0 0;font-size:.85rem;line-height:1.45;opacity:.9;grid-column:1 / -1';
      el.appendChild(n);
    }
    n.innerHTML = text;
  }
  var DATES = '<a href="/pages/christmas-delivery-dates">Check your area</a>';
  var PROMISE = 'Order by the date for your area and if it is not there by 24 December, we refund your shipping.';

  // The block is a two column grid (label | clock). With no clock showing, the label takes the whole row.
  function layout(el, clockShown){
    var lp = el.querySelector('.sv-cutoff__label');
    if (lp) lp.style.gridColumn = clockShown ? '' : '1 / -1';
  }
  function render(el){
    var kind = kindOf(el);
    var view = el.getAttribute('data-sv-view') || 'date';
    var target = end(CUT[kind].metro);
    var express = false;
    var now = new Date();
    if (now > target && kind === 'stocked'){ target = end(CUT.stocked.express_metro); express = true; }
    var ms = target - now;
    var clock = el.querySelector('.sv-cutoff__clock');
    var label = el.querySelector('.sv-cutoff__label strong');
    if (!clock) return;

    if (ms <= 0){
      clock.textContent = '';
      clock.style.display = 'none'; layout(el, false);
      if (label) label.textContent = 'This will not arrive before Christmas';
      note(el, 'The last order date for Christmas delivery has passed. We still send every order, we just cannot promise it before 25 December. <a href="/pages/christmas-delivery-dates">Delivery dates</a>.');
      return;
    }
    var hoursLeft = ms / 3600000;
    var daysLeft = Math.ceil(ms / 86400000);
    if (hoursLeft <= SHOW_CLOCK){
      var hrs = Math.floor(ms / 3600000), mins = Math.floor(ms % 3600000 / 60000);
      clock.innerHTML = hrs + '<span>hrs</span> ' + mins + '<span>min</span><span class="sv-cutoff__left"> left to order for Christmas</span>';
      clock.style.display = ''; layout(el, true);
    } else if (daysLeft <= SHOW_DAYS){
      clock.innerHTML = daysLeft + '<span>' + (daysLeft === 1 ? 'day' : 'days') + '</span><span class="sv-cutoff__left"> left to order for Christmas</span>';
      clock.style.display = ''; layout(el, true);
    } else {
      clock.textContent = '';
      clock.style.display = 'none'; layout(el, false);
    }
    var cutText = (express ? 'Express Post: order by ' : 'Order by ') + fmt(target) + ' for delivery before Christmas';
    var area = kind === 'overseas' ? ', anywhere in Australia' : ' for Brisbane, Sydney, Melbourne, Adelaide and Canberra metro. ' + DATES;
    if (view === 'product'){
      var r = ROUTE[kind], t = bneToday();
      var a = addBiz(t, r[0]), b = addBiz(t, r[1]);
      if (label) label.textContent = 'Order today, at your door around ' + fmtShort(a) + ' to ' + fmtShort(b);
      var cut = cutText.replace(' for delivery before Christmas','');
      note(el, '<strong>For Christmas:</strong> ' + cut.charAt(0).toLowerCase() + cut.slice(1) + area + '. ' + PROMISE);
    } else {
      if (label) label.textContent = cutText;
      note(el, (kind === 'overseas' ? 'Printed overseas and posted to Australia, so this date is the same everywhere. ' : 'For Brisbane, Sydney, Melbourne, Adelaide and Canberra metro. ' + DATES + '. ') + PROMISE);
    }
  }

  function init(){
    var els = document.querySelectorAll('[data-sv-cutoff]');
    if (!els.length) return;
    els.forEach(render);
    setInterval(function(){ els.forEach(render); }, 60000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
